var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"lazyload",rawName:"v-lazyload",value:(_vm.lazyload),expression:"lazyload"}],attrs:{"data-src":_vm.src,"alt":_vm.alt},on:{"load":_vm.load,"error":_vm.error}})}
var staticRenderFns = []

export { render, staticRenderFns }